import styled from 'styled-components';
import { Typography } from 'antd';

export const StyledBackToSection = styled.div`
  margin-top: 24px;
`;

export const StyledCheckEmail = styled(Typography)`
  margin-bottom: 24px;
  color: #232f6a;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 2.24px;
`;
